export const POPULAR_TEAM_COLORS = [
  { name: 'Turquoise', color: '#3bbddb' },
  { name: 'Red', color: '#ff6b6b' },
  { name: 'Green', color: '#4ecdc4' },
  { name: 'Blue', color: '#45b7d1' },
  { name: 'Purple', color: '#5f27cd' },
  { name: 'Orange', color: '#ff9f43' },
  { name: 'Pink', color: '#ff9ff3' },
  { name: 'Yellow', color: '#feca57' },
  { name: 'Teal', color: '#00d2d3' },
  { name: 'Indigo', color: '#54a0ff' },
];

export const DEFAULT_TEAM_FORM = {
  name: '',
  description: '',
  department: '',
  leader: '',
  members: '',
  status: 'active',
  color: '#3bbddb',
};
